import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
import { DATE_FORMATS } from "../constants";
import { utcToDatePicker } from "./converters/dates-helper";

const sortRecent = (a, b) => {
  return b.utcDate - a.utcDate;
};

const sortOldest = (a, b) => {
  return a.utcDate - b.utcDate;
};

export const sortStatsByDate = (stats = [], orderingType = "recent") => {
  if (orderingType === "recent") return stats.sort(sortRecent);
  return stats.sort(sortOldest);
};

export const filterUnsetValues = (stats = [], field) => {
  return stats.filter((stat) => {
    return !!stat[field];
  });
};

export const filterStatsbyDateRange = ({ stats = [], dateTo, dateFrom }) => {
  dateTo = dateTo
    ? moment(dateTo, DATE_FORMATS.DATE_PICKER_FORMAT)
    : moment(new Date());
  dateFrom = moment(dateFrom, DATE_FORMATS.DATE_PICKER_FORMAT);

  const filteredStats = stats.filter((stat) => {
    const utcDate = moment(stat.utcDate.toString(), DATE_FORMATS.UTC);
    return utcDate.isSameOrAfter(dateFrom) && utcDate.isSameOrBefore(dateTo);
  });

  return filteredStats;
};

const getLineArrays = (length = 0, values = []) => {
  const arrays = values
    .map((val) => {
      const arr = [];
      for (let i = 0; i < length; i++) {
        arr.push(val);
      }
      // arr example value: [6, 6, ...]
      return arr;
    })
    .reverse();
  return arrays;
};

const projectDateAndValues = ({ stats = [], field, offset = 0 }) => {
  return stats
    .map((stat) => {
      return {
        meta: utcToDatePicker(stat.utcDate),
        value: stat[field] + offset,
      };
    })
    .reverse();
};

/**
 *
 * @param {stats} param0 objects list to map through
 * @param {fieldToConvert} param1, field name that has an utcDate (YYYYMMDD) format value ex: 20210925
 * @param {newField} param2, fieldName that will contain the convertedDate value to format MMM D, YYYY
 * @returns newObject with newField having the converted value
 */
export const mapUtcToDatePicker = ({ stats, fieldToConvert, newField }) => {
  const newStats = cloneDeep(stats);
  return newStats.map((stat) => {
    stat[newField] = utcToDatePicker(stat[fieldToConvert]);
    // example use case: stat["date"] = utcToDatePicker(stat["utcDate"]);
    return stat;
  });
};

export const filterAndSort = ({
  stats,
  dateTo,
  dateFrom,
  field,
  orderingType = "recent",
}) => {
  let result = filterStatsbyDateRange({ stats, dateTo, dateFrom });
  result = filterUnsetValues(result, field);
  result = sortStatsByDate(result, orderingType);
  return result;
};

/**
 *
 * @param {*} stats
 * @returns and array of dates from the stats array
 */
export const getLabels = (stats) => {
  const labels = stats.map((stat) => {
    return moment(stat.utcDate, DATE_FORMATS.UTC).format(
      DATE_FORMATS.DATE_PICKER_FORMAT
    );
  });
  return labels;
};

/**
 *
 * @param {Obj} stat: stats list
 * field: field to project
 * Projects the field in stats list
 * Adds additional fixed lines if needed
 * @returns
 */
export const readyChartData = ({
  stats,
  field,
  offset = 0,
  extraLinesValues = [],
}) => {
  const rpeLine = projectDateAndValues({ stats, field, offset });
  const referenceLines = getLineArrays(stats.length, extraLinesValues);
  referenceLines.push(rpeLine);
  return referenceLines;
};

export const getActiveDayStats = ({ activeDayUtc, stats }) => {
  return stats.find((stat) => stat.utcDate === activeDayUtc);
};
